import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import Select from "react-select";
import axios from "axios";
import { API, baseURL } from "../../services/api";
import $, { data } from "jquery";
import OrgContext from "../../organisation/OrgContext";
import AuthContext from "../../components/shared/AuthContext";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment/moment";
import Swal from "sweetalert2";
import { formatNumber, isNumeric } from "../../helpers/formater";
import { useTranslation } from "react-i18next";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { useNavigate } from "react-router-dom";
import { exportInvoiceStatusHistory } from "../../helpers/ExportCsvHelper";

const InvoiceDetails = (props) => {
  const { id } = useParams();
  const [t, i18n] = useTranslation();
  const [client, setClient] = useState([]);
  const [factureEstAnnuler, setFactureEstAnnuler] = useState(false);
  const [invoiceDueDate, setInvoiceDueDate] = useState("");
  const [invoiceCreatedAt, setInvoiceCreatedAt] = useState("");
  const { organisation, changeOrg } = useContext(OrgContext);
  const { user, logout } = useContext(AuthContext);
  const [clients, setClients] = useState([]);
  const [clientToEditId, setClientToEditId] = useState(0);
  const [invoice, setInvoice] = useState([]);
  const [objet, setObjet] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [autoIncrementInvoiceNumber, setAutoIncrementInvoiceNumber] =
    useState(false);
  const [invoiceProductsState, setInvoiceProductsState] = useState([]);
  const [productIdToEdit, setProductIdToEdit] = useState(0);
  const [invoiceProducts, setInvoiceProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const [qty, setQty] = useState(0);
  const [singleSelectedProduct, setSingleSelectedProduct] = useState([]);
  const [unitPrice, setUnitPrice] = useState(0);
  const [selectedProductQty, setSelectedProductQty] = useState(0);
  const [tva, setTva] = useState(0);
  const [totalHt, setTotalHt] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [nbInvoices, setNbInvoices] = useState(0);

  //invoice status history
  const [invoiceStatusHistory, setInvoiceStatusHistory] = useState([]);
  const [invoiceStatus, setInvoiceStatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [banqueAccounts, setBanqueAccounts] = useState([]);
  const [bqAccountId, setBqAccountId] = useState(0);
  const [banquePaymentOption, setBanquePaymentOption] = useState("");
  const [chequeId, setChequeId] = useState("");
  const [payedAmount, setPayedAmount] = useState(0);
  const [invoiceProductsToDelete, setInvoiceProductsToDelete] = useState([]);
  const [reloadState, setReloadState] = useState(0);

  const leTotalHt = useRef(0);
  const leTotalTTc = useRef(0);
  const navigate = useNavigate();

  //summary
  const [summaryTotatlHt, setSummaryTotatlHt] = useState(0);
  const [summaryTotalTva, setSummaryTotalTva] = useState(0);
  const [summaryTotatlTtc, setSummaryTotatlTtc] = useState(0);

  //loaders
  const [loaderHistory, setLoaderHistory] = useState(0);
  const [invoiceDataLoader, setInvoiceDataLoader] = useState(0);
  const [invoiceClientLoader, setInvoiceClientLoader] = useState(0);
  const [invoiceProductsLoader, setInvoiceProductsLoader] = useState(0);
  const [invoiceId, setInvoiceId] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    calcInvoiceSummary();
  }, [invoiceProductsState]);
  const calcInvoiceSummary = () => {
    let totalHt = 0;
    let totalTva = 0;
    let totalTtc = 0;

    for (let i = 0; i < invoiceProductsState.length; i++) {
      totalHt += parseFloat(invoiceProductsState[i].total_ht);
      totalTtc += parseFloat(invoiceProductsState[i].total_ttc);
      totalTva +=
        parseFloat(invoiceProductsState[i].total_ttc) -
        parseFloat(invoiceProductsState[i].total_ht);
    }
    setSummaryTotatlHt(totalHt);
    setSummaryTotalTva(totalTva);
    setSummaryTotatlTtc(totalTtc);
  };

  const getNbsInvoices = async () => {
    let resp = await jwtInterceoptor.get(
      `/data/nb-factures/factures-avoir/${organisation?.id}`
    );
    if (resp.status === 200) {
      let data = resp.data;
      if (data?.status) {
        setNbInvoices(data?.nb_factures);
      }
    }
  };

  const editSingleInvoiceProduct = () => {
    if (qty == 0) {
      const errorMessage = "Veuillez remplir la quantité du produit choisie !";
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      for (let i = 0; i < invoiceProductsState.length; i++) {
        if (invoiceProductsState[i].product_id === productIdToEdit) {
          invoiceProductsState[i].qty = qty;
          invoiceProductsState[i].total_ht = leTotalHt.current.value;
          invoiceProductsState[i].total_ttc = leTotalTTc.current.value;
        }
        setInvoiceProductsState([...invoiceProductsState]);
      }
    }
  };
  const getProductData = async (selectedProduct) => {
    const response = await axios
      .get(baseURL + `/product/get/${selectedProduct.value}`)
      .then((response) => {
        setQty(0);
        setUnitPrice(response.data.data[0]["sellingPrice"]);
        setTva(response.data.data[0]["taxe_vente"].rate);
      })
      .catch((error) => console.log("error " + error));
  };

  const handleAutoIncrementInvoiceNumber = () => {
    if (autoIncrementInvoiceNumber === false) {
      $("#invoiceNumberInput").css("display", "none");
    } else {
      $("#invoiceNumberInput").css("display", "block");
    }
  };

  useEffect(() => {
    $(".all-fields-are-required-to-save").css("display", "none");
    $("#warning-create-client-first").css("display", "none");
    $("#table-rows").css("display", "none");
    $("#all-fields-are-required").css("display", "none");
    $("#warning-product-already-exists").css("display", "none");
    $("#qty-is-higher").css("display", "none");
    getInvoice();
    getNbsInvoices();
    // getInvoiceStatusHistory();
    // getAllAssociatedClients();
    // getInvoiceProducts();
    // getAllAssociatedProducts();
    // calcInvoiceSummary();
    // getInvoiceStatus();
    // getAccounts();
  }, []);

  const getInvoice = async () => {
    setLoaded(false);
    const response = await jwtInterceoptor
      .get(baseURL + `/data/user/factures/byid/${id}`)
      .then((response) => {
        if (response.data.data.length === 0) {
        } else {
          setInvoice(response.data.data);
          setData(response.data.data);
          console.log(data);
          setClient({
            value: response.data.data.client.companyName,
            label: response.data.data.client.companyName,
          });
          setInvoiceProductsState(response.data.data.products);
          setInvoiceStatusHistory(response.data.data.payment);
          setLoaded(true);
        }
      })
      .catch((error) => console.log("error " + error));
  };

  // useEffect(() => {
  //     $(".all-fields-are-required-to-save").css('display', 'none');
  //     $("#warning-create-client-first").css('display', 'none');
  //     $("#table-rows").css('display', 'none');
  //     $("#all-fields-are-required").css('display', 'none');
  //     $("#warning-product-already-exists").css('display', 'none');
  //     $("#qty-is-higher").css('display', 'none');
  //
  //     getInvoiceStatusHistory();
  //     getAllAssociatedClients();
  //     getInvoiceProducts();
  //     getAllAssociatedProducts();
  //     calcInvoiceSummary();
  //     getInvoiceStatus();
  //     getAccounts();
  // }, [reloadState]);

  const getAccounts = async () => {
    await axios
      .get(baseURL + "/paymentAccounts")
      .then((response) => {
        setBanqueAccounts(response.data.data);
        response.data.data.map((a) => {
          if (a.name === "Banques (soldes débiteurs)") {
            setBqAccountId(a.id);
          }
        });
        console.log("banque accout: ", banqueAccounts);
      })
      .catch((error) =>
        console.log("error while retrieving setBanqueAccounts : " + error)
      );
  };
  const getInvoiceStatus = async () => {
    const response = await API.get("/factures/status")
      .then((res) => {
        setInvoiceStatus(res.data.data);
      })
      .catch((error) => console.log(error));
  };

  const getInvoiceStatusHistory = async () => {
    setLoaderHistory(0);
    console.log("**** b setLoaderHistory", loaderHistory);

    const response = await jwtInterceoptor
      .get(baseURL + `/data/user/invoice_status_history/${id}`)
      .then((response) => {
        setInvoiceStatusHistory(response.data.data);
        setLoaderHistory(1);
        console.log("**** setLoaderHistory", loaderHistory);
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error)
      );
  };
  const getAllAssociatedProducts = async () => {
    const response = await axios
      .get(baseURL + `/product/getbyuser/${user.id}/${organisation.id}`)
      .then((response) => {
        setProducts(transformProductsArray(response.data.data));
        setInvoiceProductsLoader(1);
      })
      .catch((error) =>
        console.log("error while retrieving products by user" + error)
      );
  };

  const transformProductsArray = (products) => {
    let array = [];
    for (let i = 0; i < products.length; i++) {
      let obj = { value: products[i].id, label: products[i].name };
      array.push(obj);
    }
    return array;
  };

  const getInvoiceProducts = async () => {
    const response = await jwtInterceoptor
      .get(baseURL + `/data/user/facture_products/${id}`)
      .then((response) => {
        if (response.data.data.length === 0) {
        } else {
          console.log("data : ", response.data.data);
          setInvoiceProductsState(response.data.data);
          console.log("setInvoiceProductsState: ", response.data.data);
        }
      })
      .catch((error) => console.log("error " + error));
  };
  const getSelectedInvoiceClientId = async () => {
    const response = await jwtInterceoptor
      .get(baseURL + `/data/user/factures/byid/${id}`)
      .then((response) => {
        if (response.data.data.length === 0) {
        } else {
          setInvoice(response.data.data);
          setClientToEditId(response.data.data.client_id);
          setData(response.data.data);
          console.log("cliets:", clients);
        }
      })
      .catch((error) => console.log("error " + error));
  };
  const setData = (invoice) => {
    if (invoice.status_infos.name === "annuler") {
      setFactureEstAnnuler(true);
    }
    setInvoiceDueDate(invoice.due_date);
    setInvoiceCreatedAt(moment(invoice.created_at).format("MM/DD/YYYY"));
    setObjet(invoice.title);
    setInvoiceNumber(invoice.invoice_number);
    setInvoiceId(`Fact-vente-${formatNumber(id)}`);
  };
  const editSingleProduct = (productId) => {
    $(".select-article").css("display", "none");
    $(".add-new-product-to-invoice-btn").css("display", "none");
    $(".edit-single-product").css("display", "revert");
    setProductIdToEdit(productId);
    let selectedProduct = [];
    selectedProduct = invoiceProductsState.filter(
      (p) => p.product_id === productId
    );
    console.log(
      "selected product on click edit: ",
      selectedProduct[0].product.sellingPrice
    );
    setTva(selectedProduct[0].tva);
    setQty(selectedProduct[0].qty);
    setUnitPrice(selectedProduct[0].product.sellingPrice);
  };
  const deleteSingleProduct = (productId) => {
    for (let i = 0; i < invoiceProductsState.length; i++) {
      if (invoiceProductsState[i].product_id === productId) {
        invoiceProductsState.splice(i, 1);
        setInvoiceProductsToDelete([...invoiceProductsToDelete, productId]);
      }
    }
    setInvoiceProductsState([...invoiceProductsState]);
    const successMessage = "le produit a été supprimer avec succés";
    toast.success(successMessage, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  const getAllAssociatedClients = async () => {
    let fst = {};
    let snd = {};
    let res = {};
    const response = await axios
      .get(baseURL + `/client/getbyuser/${user.id}/client/${organisation.id}`)
      .then((response) => {
        if (response.data.data.length === 0) {
        } else {
          setClients(transformClientsArray(response.data.data));
          fst = transformClientsArray(response.data.data);
          setInvoiceClientLoader(1);
        }
      })
      .catch((error) => console.log("error " + error));

    const response2 = await jwtInterceoptor
      .get(baseURL + `/data/user/factures/byid/${id}`)
      .then((response) => {
        if (response.data.data.length === 0) {
        } else {
          snd = response.data.data;

          setInvoice(response.data.data);
          setClientToEditId(response.data.data.client_id);
          setData(response.data.data);
          setInvoiceDataLoader(1);
          console.log("cliets:", clients);
        }
      })
      .catch((error) => console.log("error " + error));
    res = fst.filter((c) => c.value === snd.client_id);
    setClient({
      value: res[0]["value"],
      label: res[0]["label"],
    });
  };

  const changeOfCanvasLayouts = () => {
    $("#all-fields-are-required").css("display", "none");
    $(".select-article").css("display", "block");
    $(".add-new-product-to-invoice-btn").css("display", "inline");
    $(".edit-single-product").css("display", "none");
    //reset value to default
    setSingleSelectedProduct([]);
    setQty(0);
    setUnitPrice(0);
    setTotalHt(0);
    setTva(0);
  };

  const emptyStates = () => {
    setQty(0);
    setUnitPrice(0);
    setTotalHt(0);
    setTva(0);
  };
  const checkIfProductAlreadyExist = (productId) => {
    for (let i = 0; i < invoiceProductsState.length; i++) {
      if (invoiceProductsState[i].product_id === productId) {
        console.log("exist");
        return true;
      }
    }
    console.log("! exist");
    return false;
  };
  const addNewProductToInvoice = async () => {
    emptyStates();
    if (selectedProduct.value === null || qty === 0) {
      const errorMessage = "Tous les champs sont obligatoire !";
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      if (checkIfProductAlreadyExist(singleSelectedProduct.value)) {
        const errorMessage = "Le produit déja exist !";
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        /**
         * prepare product
         * @type {{unitPrice: number, qty: number, name, totalTtc, totalHt, tva: number}}
         */
        let product = {
          product_id: singleSelectedProduct.value,
          product: {
            name: singleSelectedProduct.label,
            sellingPrice: unitPrice,
          },
          qty: qty,
          tva: tva,
          total_ht: leTotalHt.current.value,
          total_ttc: leTotalTTc.current.value,
        };
        setInvoiceProductsState([...invoiceProductsState, product]);
        console.log("after click add new product, producs state is : ", [
          ...invoiceProductsState,
          product,
        ]);
      }
    }
  };

  const transformClientsArray = (clients) => {
    let array = [];
    for (let i = 0; i < clients.length; i++) {
      let obj = { value: clients[i].id, label: clients[i].companyName };
      array.push(obj);
    }
    return array;
  };

  const save = async () => {
    // check if all tab 1 inputs are !impty
    let isOkToEdit = true;
    isOkToEdit = !(
      client.length === 0 ||
      invoiceDueDate.length === 0 ||
      invoiceProductsState.length === 0 ||
      objet.length === 0
    );
    console.log("1st: ", isOkToEdit);

    //etat= payé
    if (selectedStatus === "2" && paymentType.length === 0) {
      isOkToEdit = false;
    }
    if (selectedStatus === "2" && paymentType.length !== 0) {
      if (banquePaymentOption.length === 0) {
        isOkToEdit = false;
      } else {
        if (banquePaymentOption === "chéque" && chequeId.length === 0) {
          isOkToEdit = false;
        }
      }
    }

    console.log("2nd: ", isOkToEdit);

    //etat = payé en partie
    if (selectedStatus === "3" && paymentType.length === 0) {
      isOkToEdit = false;
    }
    if (selectedStatus === "3" && paymentType.length !== 0) {
      if (banquePaymentOption.length === 0) {
        isOkToEdit = false;
      } else {
        if (banquePaymentOption === "chéque" && chequeId.length === 0) {
          isOkToEdit = false;
        }
      }
    }
    console.log("3th: ", isOkToEdit);

    if (
      selectedStatus === "3" &&
      paymentType.length !== 0 &&
      payedAmount === 0
    ) {
      isOkToEdit = false;
    }
    console.log("4th: ", isOkToEdit);

    // console.log("selectedStatus !== '0': ", client)
    // console.log("selectedStatus !== '0': ", client[0].value)
    // isOkToEdit=false;
    if (isOkToEdit) {
      let preparedProducts = [];
      let statusIsChanged = false;
      for (let i = 0; i < invoiceProductsState.length; i++) {
        let obj = {
          product_id: invoiceProductsState[i].product_id,
          price_unit_ht: invoiceProductsState[i].product.sellingPrice,
          qty: invoiceProductsState[i].qty,
          total_ht: invoiceProductsState[i].total_ht,
          total_ttc: invoiceProductsState[i].total_ttc,
          tva: invoiceProductsState[i].tva,
          reference: Math.random().toString(36).substring(2, 7),
        };
        preparedProducts.push(obj);
      }
      /**
       * preparedProducts = [
       *     {
       *         "product_id": 96,
       *         "price_unit_ht": 1250,
       *         "qty": 2,
       *         "total_ht": 2500,
       *         "total_ttc": 3000,
       *         "tva": 20
       *     },
       *     {
       *         "product_id": 97,
       *         "price_unit_ht": 100,
       *         "qty": "1",
       *         "total_ht": "100",
       *         "total_ttc": "110",
       *         "tva": 10
       *     }
       * ]
       */
      statusIsChanged = !(selectedStatus.length === 0);

      const newStatusHistory = {
        statusIsChanged: statusIsChanged,
        status_id: selectedStatus,
        payment_account_id: paymentType,
        banquePaymentOption: banquePaymentOption,
        chequeId: chequeId,
        payed_amount: payedAmount,
      };

      let clientID = 0;

      const prepareObject = {
        invoice_id: id,
        client_id: client.value,
        total_ht: summaryTotatlHt,
        total_ttc: summaryTotatlTtc,
        total_tva: summaryTotalTva,
        title: objet,
        due_date: invoiceDueDate,
        products: preparedProducts,
        newStatusHistory: newStatusHistory,
        invoiceProductsToDelete: invoiceProductsToDelete,
      };

      const response = await jwtInterceoptor
        .post(baseURL + `/data/user/facture_vente/edit`, prepareObject)
        .then((response) => {
          Swal.fire(
            // Correction de la faute d’orthographe
            "La facture de vente a été modifiée avec succès.",
            "",
            "success"
          );
          console.log("************* after save edit, ", response.data.data);
          setReloadState(1);
        })
        .catch((error) => console.log("error " + error));
    } else {
      const errorMessage = "Merci de remplir tout les champs obligatoire !";
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  const downloadPJ = async () => {
    try {
      const response = await jwtInterceoptor.get(
        `/data/download/factures/${id}`,
        { responseType: "arraybuffer" }
      );
      if (response.status == 200) {
        const type = response.headers["content-type"];
        const blob = new Blob([response.data], {
          type: type,
          encoding: "UTF-8",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Piéce facture vte no-${formatNumber(id)}`;
        link.click();
      } else {
        Swal.fire(
          t("Oops"),
          t("Une erreur s'est produite, réessayez"),
          "error"
        );
      }
    } catch (e) {
      Swal.fire(t("Oops"), t("le fichier n'existe pas"), "error");
    }
  };

  const DownloadRecu = async (idFa, idpai) => {
    try {
      const response = await jwtInterceoptor.get(
        `/data/download/factureVent/${idFa}/${idpai}`,
        { responseType: "arraybuffer" } // We expect the PDF as an arraybuffer
      );

      if (response.status === 200) {
        // Create a new Blob object using the response data
        const blob = new Blob([response.data], { type: "application/pdf" });

        // Create a URL for the Blob
        const url = window.URL.createObjectURL(blob);

        // Create a link element
        const link = document.createElement("a");
        link.href = url;

        // Set the download attribute with a default filename
        link.setAttribute("download", `recu-${idFa}.pdf`);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("Erreur lors du téléchargement du reçu :", error);
    }
  };

  const createNewFavoir = async () => {
    if (!factureEstAnnuler) {
      //new favoir
      console.log("invocie: =>", invoice);
      let numeroDeFacture = "";
      let preparedProducts = [];
      let is_custom_invoice_number = 0;
      let incrementedValue = 0;
      let setAutoIncrementedId = true;

      numeroDeFacture = `FACT-AVOIR-${nbInvoices + 1}`;

      for (let i = 0; i < invoice.products.length; i++) {
        const ref = Math.random().toString(36).substring(2, 7);
        let obj = {
          product_id: invoice.products[i].product.id,
          price_unit_ht: invoice.products[i].price_unit_ht,
          qty: invoice.products[i].qty,
          total_ht: invoice.products[i].total_ht,
          total_ttc: invoice.products[i].total_ttc,
          tva: invoice.products[i].tva,
          reference: invoice.products[i].reference,
          details: invoice.products[i].details,
        };
        preparedProducts.push(obj);
      }

      const prepareObject = {
        user_id: user.id,
        organisation_id: organisation.id,
        client_id: invoice.client.id,
        total_ht: invoice.total_ht,
        total_ttc: invoice.total_ttc,
        total_tva: invoice.total_tva,
        title: invoice.title,
        due_date: invoice.due_date,
        created_at_date: invoice.created_at,
        status: invoice.status,
        payed_amount: invoice.payed_amount,
        products: preparedProducts,
        invoice_number: numeroDeFacture,
        is_custom_invoice_number: 0,
        facture_vente_id: id,
        statusHistory: invoiceStatusHistory,
      };

      console.log("prepareObject : => ", prepareObject);

      jwtInterceoptor
        .post("/data/user/factures_avoir/add", prepareObject)
        .then((res) => {
          Swal.fire(
            t("Votre facture d'avoir a été créée avec succès."),
            t(""),
            "success"
          );
          navigate("/sales/factureavoir/list");
        })
        .catch((error) => {
          console.log("error while save", error);
        });
    }
  };

  // Create styles
  const styles = StyleSheet.create({
    page: {
      // flexDirection: 'row',
      // backgroundColor: '#E4E4E4'
    },
    section: {
      margin: 10,
      padding: 10,
      fontSize: 11,
      //flex: 1,
      // flexGrow: 1,
    },
    header: {
      flexDirection: "row",
      marginBottom: 12,
      borderWidth: 1,
    },
    cell: {
      borderRightWidth: 1,
      justifyContent: "center",
      alignItems: "center",
      minHeight: 25,
    },
    cellRow: {
      minHeight: 25,
      padding: 5,
      paddingTop: 7,
    },
    textHeader: {
      fontSize: 10,
      fontWeight: "bold",
      textAlign: "center",
    },
    row: {
      flexDirection: "row",
    },
    textRow: {
      fontSize: 9.5,
    },
    headerPage: {
      flexDirection: "row",
      padding: 5,
      borderWidth: 1.5,
      marginBottom: 5,
    },
    leftSide: {
      flex: 1,
      justifyContent: "space-between",
    },
    centerContainer: {
      flex: 2,
      justifyContent: "space-between",
      alignItems: "center",
    },
    rightSide: {
      flex: 1,
      justifyContent: "flex-end",
      paddingLeft: 40,
    },
  });

  // Export Payment History to PDF
  const ExportPayHistory = () => {
    let date_now = new Date();
    let copyIcon = " © ";

    let last_rap = summaryTotatlTtc;
    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.section}>
            <View style={styles.headerPage}>
              <View style={styles.leftSide}>
                <Text>{organisation?.name}</Text>
                <Text>Impression provisoire</Text>
              </View>
              <View style={styles.centerContainer}>
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 18,
                    fontWeight: "bold",
                    marginBottom: 6,
                  }}
                >
                  Historique des paiements
                </Text>
                <View style={{ flexDirection: "row" }}>
                  <Text style={{ marginRight: 30, fontSize: 11.5 }}>
                    Facture
                  </Text>
                  <Text style={{ fontSize: 11.5 }}>
                    N°{" "}
                    {isNumeric(invoiceNumber)
                      ? "Fact-vente-" + formatNumber(invoiceNumber)
                      : invoiceNumber}
                  </Text>
                </View>
              </View>
              <View style={styles.rightSide}>
                <View
                  style={{ flexDirection: "row", justifyContent: "flex-start" }}
                >
                  <Text style={{ textAlign: "left", marginRight: 4 }}>
                    Type :{" "}
                  </Text>
                  <Text style={{ textAlign: "left" }}>Facture de vente</Text>
                </View>
                <View
                  style={{ flexDirection: "row", justifyContent: "flex-start" }}
                >
                  <Text style={{ textAlign: "left", marginRight: 4 }}>
                    Date de creation :{" "}
                  </Text>
                </View>
                <View
                  style={{ flexDirection: "row", justifyContent: "flex-start" }}
                >
                  <Text style={{ textAlign: "left" }}>{invoiceCreatedAt}</Text>
                </View>
              </View>
            </View>
            <View style={[styles.headerPage, { border: 0, padding: 0 }]}>
              <View style={styles.leftSide}>
                <Text style={{ fontSize: 9 }}>
                  {copyIcon}
                  <Text style={{ htmlContnet: "\\00A9" }}></Text>
                  {"ELMANAGER COMMERCIALISATION ET COMPTABILITE"}
                </Text>
              </View>
              <View style={[{ justifyContent: "flex-end" }]}>
                <View style={{ flexDirection: "row", alignItems: "flex-end" }}>
                  <Text style={{ textAlign: "right", marginRight: 4 }}>
                    Date de tirage :{" "}
                  </Text>
                  <Text style={{ textAlign: "right" }}>
                    {date_now?.getDate()}/{date_now?.getMonth() + 1}/
                    {date_now?.getFullYear()} à {date_now?.getUTCHours() + 1}:
                    {date_now?.getMinutes() < 10
                      ? "0" + date_now?.getMinutes()
                      : date_now?.getMinutes()}
                  </Text>
                </View>
              </View>
            </View>
            <View style={styles.header}>
              <View style={[styles.cell, { flex: 2 }]}>
                <Text style={styles.textHeader}>Date</Text>
              </View>
              <View style={[styles.cell, { flex: 2 }]}>
                <Text style={styles.textHeader}>Status du facture</Text>
              </View>
              <View style={[styles.cell, { flex: 2 }]}>
                <Text style={styles.textHeader}>Mode de reglement</Text>
              </View>
              <View style={[styles.cell, { flex: 3 }]}>
                <Text style={styles.textHeader}>Montan payé</Text>
              </View>
              <View style={[styles.cell, { flex: 3, borderRightWidth: 0 }]}>
                <Text>Reste à payer</Text>
              </View>
            </View>
            <View style={{ border: 1 }}>
              {invoiceStatusHistory?.map((history) => {
                let render = (
                  <View key={Math.random()} style={styles.row}>
                    <View style={[styles.cellRow, { flex: 2 }]}>
                      <Text style={styles.textRow}>
                        {moment(new Date(history.created_at)).format(
                          "DD/MM/YYYY"
                        )}
                      </Text>
                    </View>
                    <View
                      style={[styles.cellRow, { flex: 2, borderLeftWidth: 1 }]}
                    >
                      <Text style={styles.textRow}>{history.status.name}</Text>
                    </View>
                    <View
                      style={[styles.cellRow, { flex: 2, borderLeftWidth: 1 }]}
                    >
                      <Text style={styles.textRow}>
                        {history.payment_account?.code === undefined &&
                        history.payment_account?.name === undefined
                          ? ""
                          : history.payment_account.code +
                            " - " +
                            history.payment_account.name}
                      </Text>
                    </View>
                    <View
                      style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}
                    >
                      {history.status.id == 2 ? (
                        <Text style={[styles.textRow, { textAlign: "right" }]}>
                          {Number(last_rap).toFixed(2)}{" "}
                          {organisation?.currency?.code}
                        </Text>
                      ) : (
                        <Text style={[styles.textRow, { textAlign: "right" }]}>
                          {Number(history.payed_amount).toFixed(2)}{" "}
                          {organisation?.currency?.code}
                        </Text>
                      )}
                    </View>
                    <View
                      style={[styles.cellRow, { flex: 3, borderLeftWidth: 1 }]}
                    >
                      {history.status.id == 2 ? (
                        <Text style={[styles.textRow, { textAlign: "right" }]}>
                          {Number(0).toFixed(2)} {organisation?.currency?.code}
                        </Text>
                      ) : (
                        <Text style={[styles.textRow, { textAlign: "right" }]}>
                          {Number(history.rap).toFixed(2)}{" "}
                          {organisation?.currency?.code}
                        </Text>
                      )}
                    </View>
                  </View>
                );
                last_rap = history.rap;
                return render;
              })}
            </View>
          </View>
        </Page>
      </Document>
    );
  };
  return (
    <>
      <ToastContainer />
      <div className="container-fluid">
        <div className="row" style={{ zIndex: 1 }}>
          <div className="col-lg-12">
            <div class="page-header">
              <h1 class="page-title">{t("Détail de la facture")}</h1>
              <div>
                <ol className="breadcrumb">
                <li className="breadcrumb-item active" onClick={()=>{navigate("/sales/invoices/list")}}>
                    
                      {t("liste des factures de ventes")}
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {t('details')}
                  </li>
                </ol>
              </div>
            </div>
          </div>

          <div
            className="col-md-12"
            style={{ display: loaded ? "none" : "block" }}
          >
            <center>
              <div class="spinner-border text-primary me-2" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </center>
          </div>

          <div
            className="col-xl-8 col-md-12 card"
            style={{ display: !loaded ? "none" : "block" }}
          >
            <div className="card-body" style={{ overflowX: "auto" }}>
              <div class="col-xl-12">
                <div class="panel panel-primary">
                  <div class="panel-body tabs-menu-body">
                    <div class="tab-content">
                      <div class="tab-pane active">
                        <div className="row">
                          <div
                            className="col-md-12"
                            style={{
                              display: factureEstAnnuler ? "block" : "none",
                            }}
                          >
                            <div class="alert alert-danger" role="alert">
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="alert"
                                aria-hidden="true"
                              >
                                ×
                              </button>
                              <strong>
                               {t("Cette facture est annuler suite à une facture d'avoir")}
                              </strong>
                            </div>
                            <br />
                          </div>

                          <div
                            className="col-md-12"
                            style={{
                              display: factureEstAnnuler ? "none" : "block",
                            }}
                          >
                            <button
                              onClick={createNewFavoir}
                              className="btn btn-small btn-info"
                            >
                              <i className="fe fe-file"></i> {t("Créer une Facture d'avoir")}
                            </button>
                            <br />
                            <br />
                          </div>

                          <div className="col-sm-6">
                            <label htmlFor="exampleInputEmail1" className="">
                              {t('Facture no')}:
                            </label>
                            <input
                              type={"text"}
                              disabled={true}
                              className="form-control"
                              value={
                                isNumeric(invoiceNumber)
                                  ? `Fact-vente-${formatNumber(invoiceNumber)}`
                                  : invoiceNumber
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1" className="">
                                {t('Objet')}
                              </label>
                              <input
                                type="text"
                                placeholder="objet"
                                className={`form-control `}
                                onChange={(e) => setObjet(e.target.value)}
                                value={objet}
                                disabled={true}
                              />
                            </div>
                          </div>
                        </div>
                        <br />
                        <br />
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1" className="">
                                {t('Nom du client')}
                              </label>
                              <Select
                                value={client}
                                onChange={(choice) => setClient(choice)}
                                isDisabled={true}
                              />
                            </div>
                          </div>
                        </div>
                        <br />
                        <div className="row">
                          <div className="col-md-6"></div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1" className="">
                                {t('date de facture')}
                              </label>
                              <input
                                type="text"
                                placeholder="nom"
                                className={`form-control `}
                                onChange={(e) =>
                                  setInvoiceCreatedAt(e.target.value)
                                }
                                value={invoiceCreatedAt}
                                disabled={true}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6"></div>
                           <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1" className="">
                                {t("date d'échéance")}
                              </label>
                              <input
                                type="date"
                                placeholder="nom"
                                className={`form-control `}
                                onChange={(e) =>
                                  setInvoiceDueDate(e.target.value)
                                }
                                value={invoiceDueDate}
                                disabled={true}
                              />
                            </div>
                          </div> 
                        </div>
                        <br />
                        <br />
                        <table className="table">
                          <thead>
                            <tr>
                              <th scope="col">{t('DÉTAILS DE L’ARTICLE')}</th>
                              <th scope="col">{t('QUANTITÉ')}</th>
                              <th scope="col">{t('PU HT')}</th>
                              <th scope="col">{t('TVA')} %</th>
                              <th scope="col">{t('Total HT')}</th>
                              <th scope="col">{t('Total TTC')}</th>
                            </tr>
                          </thead>

                          {invoiceProductsState.map((product) => {
                            return (
                              <tr key={product.product_id}>
                                <td>{product.product.name} - {product.details}</td>
                                <td>{product.qty}</td>
                                <td>{Number(product.total_ht/product.qty).toFixed(2)}</td>
                                <td>{product.product.taxe_vente.rate + "%"}</td>
                                <td>{Number(product.total_ht).toFixed(2)}</td>
                                <td>{Number(product.total_ttc).toFixed(2)}</td>
                              </tr>
                            );
                          })}
                        </table>
                        <div className="d-flex flex-row-reverse">
                          <div className="invoiceSummary">
                            <table>
                              <tr>
                                <td className={"invoiceSummary-base"}>
                                  {t('Total HT')} :
                                </td>
                                <td>
                                  {Number(summaryTotatlHt).toFixed(2)}{" "}
                                  {organisation?.currency?.code}
                                </td>
                              </tr>
                              <tr>
                                <td className={"invoiceSummary-base"}>
                                  {t('Total TVA')} :
                                </td>
                                <td>
                                  {Number(summaryTotalTva).toFixed(2)}{" "}
                                  {organisation?.currency?.code}
                                </td>
                              </tr>
                              <tr>
                                <td className={"invoiceSummary-base"}>
                                  {t('Total TTC')} :
                                </td>
                                <td>
                                  {Number(summaryTotatlTtc).toFixed(2)}{" "}
                                  {organisation?.currency?.code}
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-12">
                            <button
                              onClick={downloadPJ}
                              className="btn btn-small"
                              style={{
                                backgroundColor: "#f1461d",
                                color: "white",
                              }}
                            >
                              <i className="fe fe-download"></i> {t('Télécharger la pièce')}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-xl-4 col-md-12"
            style={{ display: !loaded ? "none" : "block" }}
          >
            <div class="tab-pane">
              <div className="">
                <div class="container">
                  <div>
                    {invoiceStatusHistory && invoiceStatusHistory.length > 0 ? (
                      <div className={"row gx-5"}>
                        <PDFDownloadLink
                          document={<ExportPayHistory />}
                          fileName={`Historique de paiement fact no-${id}.pdf`}
                          className="btn btn-small btn-info col-md-6"
                          style={{ height: 38 }}
                        >
                          {({ blob, url, loading, error }) =>
                            loading ? (
                              t("Loading document...")
                            ) : (
                              <>
                                <span className="fe fe-download"> </span>{" "}
                                {t("Exporter PDF")}
                              </>
                            )
                          }
                        </PDFDownloadLink>
                        <button
                          className="btn btn-small btn-info col-md-6"
                          style={{ height: 38 }}
                          onClick={() => {
                            exportInvoiceStatusHistory(
                              invoiceStatusHistory,
                              isNumeric(invoiceNumber)
                                ? `Fact-vente-${formatNumber(invoiceNumber)}`
                                : invoiceNumber,
                              organisation?.currency?.code
                            );
                          }}
                        >
                          <span className="fe fe-download"> </span>
                          {t("Exporter CSV")}
                        </button>
                      </div>
                    ) : null}
                  </div>
                  <ul class="notification">
                    {invoiceStatusHistory.map((invoiceStatus) => {
                      if (invoiceStatus.status.name === "Payé en partie") {
                        return (
                          <li>
                            <div class="notification-icon">
                              <a href="javascript:void(0);"></a>
                            </div>
                            <div class="notification-body">
                              <div class="media mt-0">
                                <div class="media-body ms-3 d-flex">
                                  <div class="">
                                    <p class="fs-18 text-dark fw-bold mb-0">
                                      <span class="fe fe-clock"> </span>
                                      {moment(invoiceStatus.created_at).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </p>
                                    <p class="fs-18 text-dark fw-bold mb-0">
                                      {invoiceStatus.status.name}
                                    </p>
                                    <p class="mb-0 fs-13 text-dark">
                                      {"Mantant Payé: " +
                                        Number(invoiceStatus.payed_amount).toFixed(2) +
                                          organisation?.currency?.code
                                        }
                                    </p>
                                    <p class="mb-0 fs-13 text-dark">
                                      {"Réste à payé: " +
                                        Number(invoiceStatus.rap).toFixed(2) +
                                        organisation?.currency?.code}
                                    </p>
                                    <p class="fs-13 text-dark fw-bold mb-0">
                                      {invoiceStatus.payment_account?.code ===
                                        undefined &&
                                      invoiceStatus.payment_account?.name ===
                                        undefined
                                        ? ""
                                        : invoiceStatus.payment_account.code +
                                          " - " +
                                          invoiceStatus.payment_account.name}
                                    </p>
                                    <p class="fs-11 text-dark fw-bold mb-0">
                                      {invoiceStatus?.banquePaymentOption ===
                                        undefined &&
                                      invoiceStatus?.chequeId === undefined
                                        ? ""
                                        : invoiceStatus.banquePaymentOption ===
                                          null
                                        ? ""
                                        : invoiceStatus.banquePaymentOption +
                                          (invoiceStatus.chequeId === null ||
                                          invoiceStatus.chequeId === ""
                                            ? ""
                                            : " - " + invoiceStatus.chequeId)}
                                    </p>
                                    <p class="fs-11 text-dark fw-bold mb-0">
                                      {invoiceStatus?.banquePaymentOption ==
                                        "effet" && invoiceStatus.effetId}
                                    </p>
                                    {invoiceStatus?.banquePaymentOption && (
                                      <p className="fs-13 text-dark fw-bold mb-0">
                                        mode de paiement :{" "}
                                        {invoiceStatus?.banquePaymentOption}
                                      </p>
                                    )}
                                    {invoiceStatus.status !== 1 && (
                                      <button
                                        className="btn-sm btn-primary"
                                        onClick={() =>
                                          DownloadRecu(
                                            invoiceStatus.invoice_id,
                                            invoiceStatus.id
                                          )
                                        }
                                      >
                                        <span class="material-symbols-outlined">
                                          {t('download')}
                                        </span>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      }
                      if (invoiceStatus.status.name === "Payé") {
                        console.log(invoiceStatus);
                        return (
                          <li>
                            <div class="notification-icon">
                              <a href="javascript:void(0);"></a>
                            </div>
                            <div class="notification-body">
                              <div class="media mt-0">
                                <div class="media-body ms-3 d-flex">
                                  <div class="">
                                    <p class="fs-18 text-dark fw-bold mb-0">
                                      <span class="fe fe-clock"> </span>
                                      {moment(invoiceStatus.created_at).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </p>
                                    <p class="fs-18 text-dark fw-bold mb-0">
                                      {invoiceStatus.status.name}
                                    </p>
                                    <p class="fs-13 text-dark fw-bold mb-0">
                                      {invoiceStatus.payment_account?.code ===
                                        undefined &&
                                      invoiceStatus.payment_account?.name ===
                                        undefined
                                        ? ""
                                        : invoiceStatus.payment_account.code +
                                          " - " +
                                          invoiceStatus.payment_account.name}
                                    </p>
                                    <p class="fs-11 text-dark fw-bold mb-0">
                                      {invoiceStatus?.banquePaymentOption ===
                                        undefined &&
                                      invoiceStatus?.chequeId === undefined
                                        ? ""
                                        : invoiceStatus.banquePaymentOption +
                                            " - " +
                                            invoiceStatus.chequeId ===
                                          null
                                        ? ""
                                        : invoiceStatus.chequeId}
                                    </p>
                                    <p class="fs-11 text-dark fw-bold mb-0">
                                      {invoiceStatus?.banquePaymentOption ==
                                        "effet" && invoiceStatus.effetId}
                                    </p>
                                    {invoiceStatus?.banquePaymentOption && (
                                      <p className="fs-13  text-dark fw-bold mb-0">
                                        mode de paiement :{" "}
                                        {invoiceStatus?.banquePaymentOption}
                                      </p>
                                    )}{" "}
                                    {invoiceStatus.status !== 1 && (
                                      <button
                                        className="btn-sm btn-primary"
                                        onClick={() =>
                                          DownloadRecu(
                                            invoiceStatus.invoice_id,
                                            invoiceStatus.id
                                          )
                                        }
                                      >
                                        <span class="material-symbols-outlined">
                                          {t('download')}
                                        </span>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      } else {
                        return (
                          <li>
                            <div class="notification-icon">
                              <a href="javascript:void(0);"></a>
                            </div>
                            <div class="notification-body">
                              <div class="media mt-0">
                                <div class="media-body ms-3 d-flex">
                                  <div class="">
                                    <p class="fs-18 text-dark fw-bold mb-0">
                                      <span class="fe fe-clock"> </span>
                                      {moment(invoiceStatus.created_at).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </p>
                                    <p class="fs-18 text-dark fw-bold mb-0">
                                      {invoiceStatus.status.name}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      }
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="offcanvas offcanvas-bottom addProductCanvas"
          tabIndex="-1"
          id="offcanvasBottom"
          aria-labelledby="offcanvasBottomLabel"
        >
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasBottomLabel">
              {t('Renseigner le produit à ajouter.')}
            </h5>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i class="fe fe-x fs-18"></i>
            </button>
          </div>
          <div class="offcanvas-body">
            <div id="all-fields-are-required">
              <div
                class="alert alert-danger alert-dismissible fade show mb-0"
                role="alert"
              >
                <span class="alert-inner--icon">
                  <i class="fe fe-slash"></i>
                </span>
                <span class="alert-inner--text">
                  <strong>Attention!</strong> Tous les champs sont obligatoire !
                </span>
              </div>
              <br />
            </div>

            <div id="warning-product-already-exists">
              <div
                class="alert alert-danger alert-dismissible fade show mb-0"
                role="alert"
              >
                <span class="alert-inner--icon">
                  <i class="fe fe-slash"></i>
                </span>
                <span class="alert-inner--text">
                  <strong>Attention!</strong> Le produit déja exist !
                </span>
              </div>
              <br />
            </div>

            <div id="qty-is-higher">
              <div
                class="alert alert-danger alert-dismissible fade show mb-0"
                role="alert"
              >
                <span class="alert-inner--icon">
                  <i class="fe fe-slash"></i>
                </span>
                <span class="alert-inner--text">
                  <strong>Attention!</strong> L'article choisie est en rupture
                  de stock
                </span>
              </div>
              <br />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoiceDetails;
